// src/hooks/useModuleAccess.js
import { useModules } from '../contexts/ModuleContext'

/**
 * Hook pour vérifier l'accès aux modules
 * @param {string} moduleName - Nom du module à vérifier
 * @returns {Object} - { isEnabled, isLoading, error }
 */
export const useModuleAccess = (moduleName) => {
  const { modules, loading, error, isModuleEnabled } = useModules()

  if (loading) {
    return { isEnabled: false, isLoading: true, error: null }
  }

  if (error) {
    return { isEnabled: false, isLoading: false, error }
  }

  const isEnabled = isModuleEnabled(moduleName)

  return { isEnabled, isLoading: false, error: null }
}

/**
 * Hook pour vérifier si un module est activé (version simple)
 * @param {string} moduleName - Nom du module
 * @returns {boolean} - true si le module est activé
 */
export const useIsModuleEnabled = (moduleName) => {
  const { isModuleEnabled } = useModules()
  return isModuleEnabled(moduleName)
}
